import { EnumUserRoute } from '@components-member/userRoutes/enums';
import { keyMap } from '@locales/lokalise/keyMap';
import { PREAUTHORIZED_TYPE } from 'global.enums';
import type { BankAccountButtonProps } from './interfaces';

export const bankAccountRedirectLink: Record<PREAUTHORIZED_TYPE.BANK_ACCOUNT, BankAccountButtonProps> = {
  [PREAUTHORIZED_TYPE.BANK_ACCOUNT]: {
    title: keyMap.pspDepositDepositFormAddNewBankAccount,
    tooltip: keyMap.pspBankAccountDetailsWithdrawalHint,
    path: EnumUserRoute.bankAccounts,
  },
};

export enum PREFILL_USER_FORM_TYPE {
  NONE = 'None',
}
